import { newSlice,_fetchEntitiesService,_loadEvents,_createEntityService,_updateEntityService,_deleteEntityService} from "../../../redux/slices/common/sliceFunctions";

var entitiesName = 'pollQuestion';

const entitiesSlice = newSlice(entitiesName);
const events = _loadEvents(entitiesSlice);

export const entitiesSelector = (state) => state[entitiesName];
export default entitiesSlice.reducer;

/*export function fetchEntitiesService(dataSlice) {
  dataSlice.dataUrl.code="GET_ACC_POLLQUESTION";
  return _fetchEntitiesService(dataSlice,events);
}*/
export function createEntityService(dataSlice) {
  dataSlice.dataUrl.code="POST_ACC_POLLQUESTION";
  return _createEntityService(dataSlice,events);
}

export function updateEntityService(dataSlice) {
  dataSlice.dataUrl.code="PUT_ACC_POLLQUESTION";
  dataSlice.dataUpdate.isPost=true;
  return _updateEntityService(dataSlice,events);
}

export function deleteEntityService(dataSlice) {
  dataSlice.dataUrl.code="DELETE_ACC_POLLQUESTION";
  return _deleteEntityService(dataSlice,events);
}

/* Custom functions */
export function fetchQuestByPoll(dataSlice) {
  dataSlice.dataUrl.code = "GET_ACC_POLLQUESTION_BY_POLL";
  return _fetchEntitiesService(dataSlice, events);
}

/* Custom functions */
export function fetchQuestByPollByContact(dataSlice) {
  dataSlice.dataUrl.code = "GET_ACC_POLLQUESTION_BY_POLL_BY_CONTACT";
  return _fetchEntitiesService(dataSlice, events);
}


